<template>
  <div class="flex flex-wrap mb-2">
    <div class="w-96 flex-1 bg-white rounded-xl space-y-6 p-6">
      <div class="bg-gray-100 rounded-lg p-2">
        <span class="font-bold text-grap-700 align-middle">{{lang['components']['Event']['AdvertisingMaterial']['title']}}</span>
        <div v-show="stageIndex != 0 && _useStatus == true" class="float-right">
          <i
            class="pi pi-exclamation-circle align-middle text-gray-300 mr-2 leading-relaxed "
            v-tooltip.left="'開啟套用前階段設定，會將所有互動數據累積至同一個素材下，需與前階段設定相同目標，才可套用'"
          ></i>
          <span class="text-sm mr-2">套用前階段設定</span>
          <InputSwitch v-model="viewDatalistData.ditto_creative" class="-my-1" />
        </div>
      </div>
      <!-- <div class="flex-1 space-y-4 tab"> -->
      <div class="flex-1 space-y-4 tab overflow-hidden">
        <!-- <div v-if="goalsObjectiveData != 'MESSAGES'" class="space-y-2" :class="{ 'border-4 border-blue-300': guideStep === 5801 }">
          <div class="flex">
            <div class="leading-relaxed">
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AdvertisingMaterial']['optimize_title']}}</span>
            </div>
            <div class="text-grap-700 text-sm ml-2 mt-1">
              <InputSwitch v-model="viewDatalistData.creative_optimize" :disabled="viewDatalistData.disabled_creative_optimize" class="-my-1" />
              <span class="mx-1">{{lang['components']['Event']['AdvertisingMaterial']['optimize_switch']}}</span>
            </div>
            <i
              class="pi pi-exclamation-circle align-middle text-gray-300 ml-2 leading-relaxed"
              v-tooltip="`${lang['components']['Event']['AdvertisingMaterial']['optimize_info']}`"
            ></i>
          </div>
        </div> -->
        <div class="space-y-2 pb-8">
          <div>
            <span v-if="goalsObjectiveData != 'MESSAGES' && !editPageType" class="text-red-500 text-sm">*</span>
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AdvertisingMaterial']['ad_content_title']}}</span>
            <i
              v-if="goalsObjectiveData != 'MESSAGES'"
              class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
              v-tooltip="`${lang['components']['Event']['AdvertisingMaterial']['title_info']}`"
            ></i>
          </div>
          <!-- 新手教學 -->
          <div class="flex scrollbar-x" :class="{ 'ring-4 border-blue-400': guideStep === 59 }">
            <div
              v-for="(item, index) in viewDatalistData.creative_array"
              :key="index"
              @click="adContent(index)"
            >
              <div class="bg-white -mb-1.5 text-left">
                <span v-if="item.tagType == 0" class="block bg-white rounded-t-md font-bold" style="height:24px;"></span>
                <span
                  v-if="item.tagType == 3"
                  class="text-center text-xs pl-1.5 pt-1 pr-1.5 pb-0.5 rounded-t-md font-bold"
                  :class="[
                    currentTab === index? 'bg-yellow-300 text-blue-700' : 'bg-blue-400'
                  ]"
                >{{lang['components']['Event']['AdvertisingMaterial']['tag_status_test']}}</span>
                <span
                  v-if="item.tagType == 4"
                  class="text-center text-xs pl-1.5 pt-1 pr-1.5 pb-0.5 rounded-t-md font-bold"
                  :class="[
                    currentTab === index? 'bg-yellow-300 text-blue-700' : 'bg-green-400'
                  ]"
                >{{lang['components']['Event']['AdvertisingMaterial']['tag_status_good']}}</span>
                <span
                  v-if="item.tagType == 5"
                  class="text-center text-xs bg-red-400 pl-1.5 pt-1 pr-1.5 pb-0.5 rounded-t-md font-bold"
                  :class="[
                    currentTab === index? 'bg-yellow-300 text-blue-700' : 'bg-red-400'
                  ]"
                >{{lang['components']['Event']['AdvertisingMaterial']['tag_status_bad']}}</span>
                <span
                  v-if="item.tagType == 1"
                  class="text-center text-xs bg-gray-100 pl-1.5 pt-1 pr-1.5 pb-0.5 rounded-t-md font-bold"
                  :class="[
                    currentTab === index? 'bg-yellow-300 text-blue-700' : 'bg-gray-100'
                  ]"
                >{{lang['components']['Event']['AdvertisingMaterial']['tag_status_create']}}</span>
                <span
                  v-if="item.tagType == 2"
                  class="text-center text-xs bg-gray-100 pl-1.5 pt-1 pr-1.5 pb-0.5 rounded-t-md font-bold"
                  :class="[
                    currentTab === index? 'bg-yellow-300 text-blue-700' : 'bg-gray-100'
                  ]"
                >{{lang['components']['Event']['AdvertisingMaterial']['tag_status_delete']}}</span>
              </div>

              <div
                class="flex px-4 py-2 cursor-pointer bg-gray-100 whitespace-nowrap"
                :class="[
                  currentTab === index? 'bg-yellow-300 text-blue-700' :
                  item.tagType == 3? 'bg-blue-400':
                  item.tagType == 4? 'bg-green-400':
                  item.tagType == 5? 'bg-red-400': 'bg-gray-100'
                ]"
              >
                <p v-if="!item.isEdit" class="flex-none truncate w-24">
                  {{ item.title ? item.title : lang['components']['Event']['AdvertisingMaterial']['ad_name'] }}
                </p>

                <!-- <input
                  v-if="item.isEdit"
                  :disabled="editPageType && returnCampaignObjectiveData != 'LEAD_GENERATION'"
                  v-model="item.title"
                  class="p-inputtext p-component py-0 w-40 underline-box border-show bg-transparent"
                  type="text"
                  placeholder="請填寫廣告名稱"
                  v-on:keyup="isChangeData()"
                /> -->
                <input
                  v-if="item.isEdit"
                  v-model="item.title"
                  class="p-inputtext p-component py-0 w-40 underline-box border-show bg-transparent"
                  type="text"
                  :placeholder="lang['components']['Event']['AdvertisingMaterial']['ad_name_info']"
                  v-on:keyup="isChangeData()"
                />
                <!-- 新手教學 -->
                <i
                  v-if="currentTab === index"
                  @click="item.isEdit = !item.isEdit"
                  class="pi pi-pencil mt-2 ml-2"
                  :class="{ 'ring-4 border-blue-400': guideStep === 59 }"
                  style="fontSize: 0.8rem"
                ></i>
              </div>
            </div>
            <div class="px-4 py-2 cursor-pointer" :class="{'mt-5' : editPageType}" @click="addItem()">
              <!-- 新手教學 -->
              <i class="pi pi-plus" style="fontSize: 0.8rem" :class="{ 'ring-4 border-blue-400': guideStep === 61 }"></i>
            </div>
          </div>
          <!-- <div class="flex text-gray-500">
            <div
              class="px-4 py-2 cursor-pointer bg-gray-100"
              :class="{
                'bg-yellow-300': currentTab === index
              }"
              v-for="(item, index) in viewDatalistData.creative_array"
              :key="index"
              @click="adContent(index)"
            >
              <span v-if="!item.isEdit">{{ item.title }}</span>

              <input
                v-if="item.isEdit"
                v-model="item.title"
                class="p-inputtext p-component py-0 w-40 underline-box border-show bg-transparent"
                type="text"
                placeholder="廣告"
              />
              <i
                v-if="currentTab === index"
                @click="item.isEdit = !item.isEdit"
                class="pi pi-pencil ml-2"
                style="fontSize: 0.8rem"
              ></i>
            </div>
            <div class="px-4 py-2 cursor-pointer" @click="addItem()">
              <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
            </div>
          </div> -->
          <TabView v-model:activeIndex="currentTab">
            <template v-for="(item, index) in viewDatalistData.creative_array" :key="index">
              <TabPanel>
                <template #hearder>
                  <div></div>
                </template>
                <div class="space-y-2 pb-8 my-4">
                  <div>
                    <span class="text-red-500">*</span>
                    <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AdvertisingMaterial']['format_info']}}</span>
                    <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'格式'"></i> -->
                  </div>
                  <div>
                    <!-- 新手教學 -->
                    <button
                      class="text-sm border border-gray-900 hover:bg-gray-900 hover:text-white rounded-md px-4 py-1"
                      :class="[
                        item.type == 1 ? 'bg-gray-900' : 'bg-white',
                        item.type == 1 ? 'text-white' : 'text-gray-900',
                        guideStep === 63 ? 'ring-4 ring-gray-400 border-gray-900' : null,
                      ]"
                      @click="changeType(index, 1)"
                    >
                      <i class="pi pi-video mr-3" style="fontSize: 0.8rem"></i>
                      {{lang['components']['Event']['AdvertisingMaterial']['single_material']}}
                    </button>
                    <!-- 新手教學 -->
                    <!-- <button
                      class="text-sm border border-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1 ml-4"
                      :class="[
                        item.type == 2 ? 'bg-blue-700' : 'bg-white',
                        item.type == 2 ? 'text-white' : 'text-blue-700',
                        guideStep === 63 ? 'ring-4 border-blue-400' : null
                      ]"
                      @click="changeType(index, 2)"
                    >
                      <i class="pi pi-images" style="fontSize: 0.8rem"></i>
                      {{lang['components']['Event']['AdvertisingMaterial']['carousel_material']}}
                    </button> -->
                    <!-- 新手教學 -->

                    <button
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 ml-4 float-right"
                      :class="{ 'ring-4 border-blue-400': guideStep === 62 }"
                      @click="removeAd(index)"
                    >
                      {{lang['components']['Event']['AdvertisingMaterial']['delete_material']}}
                    </button>

                    <!-- <button
                      v-if="item.tagType != 5 && item.tagType != 2"
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 ml-4 float-right"
                      :class="{ 'ring-4 border-blue-400': guideStep === 62 }"
                      @click="removeAd(index)"
                    >
                      {{lang['components']['Event']['AdvertisingMaterial']['delete_material']}}
                    </button>
                    <button
                      v-if="item.tagType == 2"
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 ml-4 float-right"
                      :class="{ 'ring-4 border-blue-400': guideStep === 62 }"
                      @click="backAd(index)"
                    >
                      {{lang['components']['Event']['AdvertisingMaterial']['regain_material']}}
                    </button> -->

                  </div>
                  <hr />
                </div>
                <div class="space-y-2 pb-8 my-4" v-if="item.type == 1" style="position:relative">
                  <loading :active="!showMaterialSingle"
                          :can-cancel="true"
                          :on-cancel="onCancel"
                          :is-full-page="false"
                          :color="'#fff'"
                          :background-color="'#000'"
                          :opacity="'0.8'"
                          :loader=" dots">
                  </loading>
                  <div>
                    <span class="text-red-500">*</span>
                    <span class="text-grap-700 align-middle text-sm"
                      >{{lang['components']['Event']['AdvertisingMaterial']['material_setting']}}</span
                    >
                    <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'格式'"></i> -->
                  </div>
                  <!-- 新手教學 -->
                  <div :class="{ 'ring-4 border-blue-400': guideStep === 64 }">
                    <button
                      v-on:click="getImageVideoList(item.type, 0)"
                      class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1"
                      v-if="item.materialSingle.length == 0"
                    >
                      <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                      {{lang['components']['Event']['AdvertisingMaterial']['add_material']}}
                    </button>
                    <div
                      v-for="(itemSingle, i) in item.materialSingle"
                      :key="i"
                      class="flex justify-between bg-gray-100 rounded-xl border overflow-hidden p-1 w-full hover:border-grap-400 mt-4"
                    >
                      <div class="flex p-1">
                        <div class="md:flex-shrink-0">
                          <img
                            class="h-24 w-24 rounded-xl object-cover"
                            :src="itemSingle?.imgSrc"
                          />
                        </div>
                        <div class="mx-8">
                          <p class="text-gray-800 text-sm">
                            {{ itemSingle?.fileName ? itemSingle?.fileName : "" }}
                            <template v-for="(_tmp_object_spec, obj_index) in itemSingle.object_spec">
                              <template v-if="obj_index == 'type' && _tmp_object_spec == 'image'">
                                {{lang['components']['Event']['AdvertisingMaterial']['material_type_image']}}
                              </template>
                              <template v-if="obj_index == 'type' && _tmp_object_spec == 'video'">
                                {{lang['components']['Event']['AdvertisingMaterial']['material_type_video']}}
                              </template>
                            </template>
                          </p>
                          <p class="text-gray-500 text-sm">{{ itemSingle.size }}</p>
                          <button
                            class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 mt-4"
                            v-on:click="getImageVideoList(item.type, 0)"
                          >
                            {{lang['components']['Event']['AdvertisingMaterial']['change_material']}}
                          </button>
                        </div>
                      </div>
                      <!-- <i class="pi pi-times cursor-pointer text-right m-2"></i> -->
                    </div>
                  </div>
                </div>
                <div class="space-y-2 pb-8 my-4" v-if="item.type == 2">
                  <div>
                    <!-- <span class="text-red-500">*</span> -->
                    <span class="text-grap-700 align-middle text-sm"
                      >{{lang['components']['Event']['AdvertisingMaterial']['carousel_card']}}</span
                    >
                    <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'格式'"></i> -->
                  </div>
                  <!-- 新手教學 -->
                  <div :class="{ 'ring-4 border-blue-400': guideStep === 68 }">
                    <draggable
                      v-if="item.materials.length"
                      v-model="item.materials"
                      :disabled="isEdit"
                      @start="drag = true"
                      @end="drag = false"
                      item-key="id"
                    >
                      <template #item="{ element }" >
                        <div
                          class="bg-white bg-blue-100 rounded-xl border overflow-hidden p-4 w-full hover:border-grap-400 mt-4 space-y-2"
                        >
                          <div class="flex justify-between ">
                            <div class="flex p-1">
                              <!-- 新手教學 -->
                              <div class="my-auto -ml-2" :class="{ 'ring-4 border-blue-400': guideStep === 69 }">
                                <i
                                  class="pi pi-ellipsis-v"
                                  style="fontSize: 1.3rem"
                                ></i>
                                <i
                                  class="pi pi-ellipsis-v -ml-2"
                                  style="fontSize: 1.3rem"
                                ></i>
                              </div>
                              <div class="md:flex-shrink-0">
                                <img
                                  class="h-24 w-24 rounded-xl object-cover cursor-pointer"
                                  v-if="element.imgSrc"
                                  :src="element.imgSrc"
                                  @click="element.isEdit = !element.isEdit"
                                />
                                <div
                                  v-else
                                  class="h-24 w-24 rounded-xl border cursor-pointer border-gray-400 text-center"
                                  @click="element.isEdit = !element.isEdit"
                                >
                                  <i
                                    class="pi pi-plus my-7"
                                    style="fontSize: 2rem"
                                  ></i>
                                </div>
                              </div>
                              <div class="mx-8 my-auto">
                                <p class="text-gray-800 text-sm">
                                  <template v-if="element.object_spec.title != ''">
                                    {{element.object_spec.title}}
                                  </template>
                                  <template v-if="element.object_spec.name != ''">
                                    {{element.object_spec.name}}
                                  </template>
                                  <template v-if="element.object_spec.type == 'image'">
                                    {{lang['components']['Event']['AdvertisingMaterial']['material_type_image']}}
                                  </template>
                                  <template v-if="element.object_spec.type == 'video'">
                                    {{lang['components']['Event']['AdvertisingMaterial']['material_type_video']}}
                                  </template>
                                </p>
                                <p class="text-gray-500 text-sm">
                                  <span v-if="element.title != ''" class="truncate w-20">
                                    {{ element.title }}
                                  </span>
                                  <span v-if="element.title == ''" class="w-20">
                                    {{lang['components']['Event']['AdvertisingMaterial']['not_title']}}
                                  </span>
                                   -
                                   <span v-if="element.description != ''" class="truncate w-20">
                                    {{ element.description }}
                                  </span>
                                  <span v-if="element.description == ''" class="w-20">
                                    {{lang['components']['Event']['AdvertisingMaterial']['not_description']}}
                                  </span>
                                  <!--  -
                                   <span v-if="element.website != ''" class="truncate w-20">
                                    {{ element.website }}
                                  </span>
                                  <span v-if="element.website == ''" class="w-20">
                                    無網址
                                  </span> -->
                                </p>
                              </div>
                            </div>
                            <!-- 新手教學 -->
                            <div class="flex flex-col">
                              <i
                                v-if="item.materials.length > 2"
                                class="pi pi-times cursor-pointer text-right m-2"
                                @click="removeItem(currentTab, element.index)"
                              ></i>
                              <i
                                class="pi cursor-pointer my-auto text-right mx-2 text-blue-400"
                                :class="[element.isEdit ? 'pi-angle-up' : 'pi-pencil', guideStep === 70 ? 'ring-4 border-blue-400' : null ]"
                                style="fontSize: 1.2rem"
                                @click="element.isEdit = !element.isEdit"
                              ></i>
                            </div>
                          </div>
                          <div
                            class="w-full flex-1 bg-white rounded-xl space-y-6 p-6 transition duration-500"
                            v-show="element.isEdit"
                            style="position:relative"
                          >
                          <loading :active="!showMaterial"
                                  :can-cancel="true"
                                  :on-cancel="onCancel"
                                  :is-full-page="false"
                                  :color="'#fff'"
                                  :background-color="'#000'"
                                  :opacity="'0.8'"
                                  :loader=" dots">
                          </loading>
                            <div
                              class="flex justify-between bg-gray-100 rounded-xl border overflow-hidden p-1 w-full hover:border-grap-400 mt-4"
                              v-if="element.imgSrc"
                            >
                              <div class="flex p-1">
                                <div class="md:flex-shrink-0">
                                  <img
                                    class="h-24 w-24 rounded-xl object-cover"
                                    :src="element.imgSrc"
                                  />
                                </div>
                                <div class="mx-8">
                                  <p class="text-gray-800 text-sm">
                                    <template v-if="element.object_spec.title != ''">
                                      {{element.object_spec.title}}
                                    </template>
                                    <template v-if="element.object_spec.name != ''">
                                      {{element.object_spec.name}}
                                    </template>
                                    <template v-if="element.object_spec.type == 'image'">
                                      {{lang['components']['Event']['AdvertisingMaterial']['material_type_image']}}
                                    </template>
                                    <template v-if="element.object_spec.type == 'video'">
                                      {{lang['components']['Event']['AdvertisingMaterial']['material_type_video']}}
                                    </template>
                                  </p>
                                  <p class="text-gray-500 text-sm">{{element.object_spec.width}}*{{element.object_spec.height}}</p>
                                  <button
                                    class="text-sm border border-blue-400 bg-blue-400 text-white rounded-md px-4 py-1 mt-4"
                                    v-on:click="getImageVideoList(item.type, element.index)"
                                  >
                                    {{lang['components']['Event']['AdvertisingMaterial']['change_material']}}
                                  </button>
                                </div>
                              </div>
                              <i
                                v-if="false"
                                class="pi pi-times cursor-pointer text-right m-2"
                                @click="removeItem(currentTab, element.index)"
                              ></i>
                            </div>
                            <!-- 新手教學 -->
                            <button
                              v-on:click="getImageVideoList(item.type, element.index)"
                              class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1"
                              :class="{ 'ring-4 border-blue-400': guideStep === 71 }"
                              v-else
                            >
                              <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                              {{lang['components']['Event']['AdvertisingMaterial']['add_material']}}
                            </button>
                            <div>
                              <span class="text-grap-700 align-middle text-sm"
                                >{{lang['components']['Event']['AdvertisingMaterial']['material_title']}}</span
                              >
                              <input
                                class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                                type="text"
                                :placeholder="lang['components']['Event']['AdvertisingMaterial']['material_title_placeholder']"
                                v-model="element.title"
                                v-on:keyup="isChangeData()"
                                v-on:focus="lock()"
                                v-on:blur="unlock()"
                              />
                            </div>
                            <div>
                              <span class="text-grap-700 align-middle text-sm"
                                >{{lang['components']['Event']['AdvertisingMaterial']['material_description']}}</span
                              >
                              <input
                                class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                                type="text"
                                :placeholder="lang['components']['Event']['AdvertisingMaterial']['material_description_placeholder']"
                                v-model="element.description"
                                v-on:keyup="isChangeData()"
                                v-on:focus="lock()"
                                v-on:blur="unlock()"
                              />
                            </div>
                            <!-- <div>
                              <span class="text-grap-700 align-middle text-sm"
                                >網站網址</span
                              >
                              <input
                                class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                                type="text"
                                placeholder="請輸入網站網址"
                                :disabled="editPageType"
                                v-model="element.website"
                                v-on:keyup="isChangeData()"
                              />
                            </div> -->
                          </div>
                        </div>
                      </template>
                    </draggable>

                    <!-- <div
                      class="bg-white bg-blue-100 rounded-xl border overflow-hidden p-4 w-full hover:border-grap-400 mt-4 space-y-2"
                      v-for="(material, materIndex) in item.materials"
                      :key="materIndex"
                    >
                      <div class="flex justify-between ">
                        <div class="flex p-1">
                          <div class="my-auto -ml-2">
                            <i
                              class="pi pi-ellipsis-v"
                              style="fontSize: 1.3rem"
                            ></i>
                            <i
                              class="pi pi-ellipsis-v -ml-2"
                              style="fontSize: 1.3rem"
                            ></i>
                          </div>
                          <div class="md:flex-shrink-0">
                            <img
                              class="h-24 w-24 rounded-xl object-cover cursor-pointer"
                              v-if="material.imgSrc"
                              :src="material.imgSrc"
                            />
                            <div
                              v-else
                              class="h-24 w-24 rounded-xl border cursor-pointer border-gray-400 text-center"
                            >
                              <i
                                class="pi pi-plus my-7"
                                style="fontSize: 2rem"
                              ></i>
                            </div>
                          </div>
                          <div class="mx-8 my-auto">
                            <p class="text-gray-800 text-sm">Untitled</p>
                            <p class="text-gray-500 text-sm">
                              標題：{{ material.title }}
                            </p>
                          </div>
                        </div>
                        <i
                          class="pi cursor-pointer my-auto text-right mx-2"
                          :class="[material.isEdit ? 'pi-angle-up' : 'pi-pencil']"
                          style="fontSize: 1.2rem"
                          @click="material.isEdit = !material.isEdit"
                        ></i>
                      </div>
                      <div
                        class="w-full flex-1 bg-white rounded-xl space-y-6 p-6 transition duration-500"
                        v-show="material.isEdit"
                      >
                        <div
                          class="flex justify-between bg-gray-100 rounded-xl border overflow-hidden p-1 w-full hover:border-grap-400 mt-4"
                          v-if="material.imgSrc"
                        >
                          <div class="flex p-1">
                            <div class="md:flex-shrink-0">
                              <img
                                class="h-24 w-24 rounded-xl object-cover"
                                :src="material.imgSrc"
                              />
                            </div>
                            <div class="mx-8">
                              <p class="text-gray-800 text-sm">Untitled</p>
                              <p class="text-gray-500 text-sm">800*800</p>
                              <button
                                class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1 mt-4"
                                v-on:click="getImageVideoList(item.type, materIndex)"
                              >
                                更換素材
                              </button>
                            </div>
                          </div>
                          <i
                            class="pi pi-times cursor-pointer text-right m-2"
                          ></i>
                        </div>
                        <button
                          v-on:click="getImageVideoList(item.type, materIndex)"
                          class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1"
                          v-else
                        >
                          <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                          新增影音素材
                        </button>
                        <div>
                          <span class="text-grap-700 align-middle text-sm"
                            >標題</span
                          >
                          <input
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            placeholder="請輸入標題"
                            v-model="material.title"
                          />
                        </div>
                        <div>
                          <span class="text-grap-700 align-middle text-sm"
                            >說明</span
                          >
                          <input
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            placeholder="請輸入說明"
                            v-model="material.description"
                          />
                        </div>
                        <div>
                          <span class="text-grap-700 align-middle text-sm"
                            >網站網址</span
                          >
                          <input
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            placeholder="請輸入網站網址"
                            v-model="material.website"
                          />
                        </div>
                      </div>
                    </div> -->
                    <!-- 新手教學 -->
                    <button
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 mt-4"
                      :class="{ 'ring-4 border-blue-400': guideStep === 67 }"
                      @click="addMaterials(index)"
                    >
                      {{lang['components']['Event']['AdvertisingMaterial']['add_carousel_card']}}
                    </button>
                    <!-- 新手教學 -->
                    <label class="inline-flex items-center mt-3 w-full" v-if="item.type == 2" :class="{ 'ring-4 border-blue-400': guideStep === 73 }">
                      <input type="checkbox" v-model="item.multi_share_optimized" v-on:change="isChangeData()"/>
                      <span class="ml-2 text-gray-700 text-sm"
                        >{{lang['components']['Event']['AdvertisingMaterial']['multi_share_optimized_text']}}</span
                      >
                    </label>
                  </div>
                </div>
                <div class="space-y-2 pb-8 my-4">
                  <div>
                    <span class="text-red-500 text-sm">*</span>
                    <span class="text-grap-700 align-middle text-sm"
                      v-if="item.type == 1"
                      >{{lang['components']['Event']['AdvertisingMaterial']['material_message_type_1']}}</span
                    >
                    <!-- <span class="text-grap-700 align-middle text-sm"
                      v-if="item.type == 2"
                      >{{lang['components']['Event']['AdvertisingMaterial']['material_message_type_2']}}</span
                    > -->
                    <textarea
                      class="w-full h-24 px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['AdvertisingMaterial']['material_message_placeholder']"
                      v-model="item.message"
                      v-on:keyup="isChangeData()"
                    ></textarea>
                  </div>
                  <!-- <div v-if="item.type == 1">
                    <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AdvertisingMaterial']['material_single_title']}}</span>
                    <input
                      class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['AdvertisingMaterial']['material_single_title_placeholder']"
                      v-model="item.materialSingle[0].title"
                      v-on:keyup="isChangeData()"
                    />
                  </div> -->
                  <!-- <div v-if="item.type == 1">
                    <span class="text-grap-700 align-middle text-sm"
                      >{{lang['components']['Event']['AdvertisingMaterial']['material_single_description']}}</span
                    >
                    <textarea
                      class="w-full h-24 px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['AdvertisingMaterial']['material_single_description_placeholder']"
                      v-model="item.materialSingle[0].description"
                      v-on:keyup="isChangeData()"
                    ></textarea>
                  </div> -->
                  <!-- <div v-if="item.type == 1">
                    <span class="text-grap-700 align-middle text-sm"
                      >網站網址</span
                    >
                    <input
                      class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      placeholder="請輸入點擊後要導向的網址"
                      :disabled="editPageType"
                      v-model="item.line"
                      v-on:keyup="isChangeData()"
                    >
                  </div> -->
                  <div v-if="item.type == 1">
                    <span class="text-red-500 text-sm">*</span>
                    <span class="text-grap-700 align-middle text-sm"
                      >{{lang['components']['Event']['AdvertisingMaterial']['item_caption']}}</span
                    >
                    <input
                      class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['AdvertisingMaterial']['item_caption_placeholder']"
                      v-model="item.caption"
                      v-on:keyup="isChangeData()"
                    >
                  </div>
                </div>
                <!-- <div
                  class="text-sm text-blue-300 underline cursor-pointer"
                  @click="moreInput = !moreInput"
                >
                  {{ moreWording }}更多選項
                  <i
                    class="pi"
                    :class="[moreInput ? 'pi-caret-up' : 'pi-caret-down']"
                    style="fontSize: 0.8rem"
                  ></i>
                </div> -->
                <!-- <div class="space-y-2 pb-8 my-4" v-show="moreInput"> -->
                <!-- <div class="space-y-2 pb-8 my-4">
                  <div class="flex flex-col" :class="{ 'ring-4 border-blue-400': guideStep === 65 || guideStep === 74 }">
                    <span class="text-grap-700 align-middle text-sm"
                      >{{lang['components']['Event']['AdvertisingMaterial']['call_active_text']}}</span
                    >
                    <Dropdown
                      v-model="item.callActive"
                      optionLabel="name"
                      optionValue="code"
                      :options="callActiveList"
                      :placeholder="lang['components']['Event']['AdvertisingMaterial']['call_active_placeholder']"
                      v-on:change="isChangeData()"
                      class="w-1/3 rounded-md"
                    />
                  </div>
                </div> -->
              </TabPanel>
            </template>
          </TabView>
        </div>
      </div>
    </div>
    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar">
      <div class="flex flex-col bg-white rounded-xl space-y-2 p-4">
        <div v-html="prview_now" v-if="prview_now"></div>
        <div v-html="prview_single" v-if="prview_single"></div>
      </div>
    </div>
    <!-- <div class="w-1/4 rounded-xl space-y-2 px-4">
      <div class="flex flex-col bg-white rounded-xl space-y-2 p-4">
        <div class="flex justify-between">
          <span class="text-gray-700">預覽</span>
          <div class="bg-gray-500 text-white rounded-xl">
            <a href="javascript:void(0);"
              ><i class="pi pi-angle-left mx-2"></i
            ></a>
            <a href="javascript:void(0);"
              ><i class="pi pi-angle-right mx-2"></i
            ></a>
          </div>
        </div>
        <hr class="-mx-4" />
        <div class="overflow-hidden w-full">
          <div class="flex">
            <div class="md:flex-shrink-0">
              <img
                class="h-8 w-8 rounded-2xl object-cover"
                src="http://placehold.it/100x100"
              />
            </div>
            <div class="mx-2">
              <p class="text-gray-800 text-xs">寓意科技</p>
              <p class="text-gray-500 text-xs">
                <img :src="fb1Image" class="h-3" />
              </p>
            </div>
            <i
              class="pi pi-ellipsis-h m-auto w-1/3 text-right"
              style="fontSize: 0.8rem"
            ></i>
          </div>
        </div>
        <div class="text-sm">貼文內容貼文內容貼文內容</div>
        <div class="border-b border-gray-400">
          <img src="http://placehold.it/800x600" class="w-full" />
          <div class="flex justify-between bg-gray-200 p-2">
            <div>
              <p class="text-gray-800 text-xs">EXAMPLE.COM</p>
              <p class="text-gray-500 text-xs">標題</p>
            </div>
            <button
              class="text-xs border border-gray-400 text-gray-400 rounded-md h-6"
            >
              發送訊息
            </button>
          </div>
        </div>
        <img :src="fb2Image" alt="" />
      </div>
    </div> -->

    <!-- <ModifyWindows v-model:show="showVideoWindows" size="sm"> -->
    <ModifyWindows v-model:show="showVideoWindows">
      <template v-slot:header>
        <span class="mr-2 text-2xl font-semibold align-sub">{{lang['components']['Event']['AdvertisingMaterial']['material_block_title']}}</span>
        <button @click="materialUpdate()" class="button border-blue">
          {{lang['components']['Event']['AdvertisingMaterial']['material_block_update']}}
        </button>
        <button v-if="false" @click="$refs.videoUpload.click()" class="button border-blue">
          <img
            class="mr-2 inline-block align-baseline"
            src="../../assets/upload.svg"
          />{{lang['components']['Event']['AdvertisingMaterial']['material_block_upload']}}
        </button>
        <input ref="videoUpload" type="file" class="hidden" />
        <a href="https://ads.tiktok.com/i18n/home" target="_blank">{{lang['components']['Event']['AdvertisingMaterial']['material_block_title_info']}}</a>
      </template>

      <template v-slot:content>
        <div class="flex flex-wrap w-full">
          <loading :active="!showVideoLoading"
                  :can-cancel="true"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'">
          </loading>
          <div class="flex flex-wrap p-2 w-full scrollbar-y" style="position:relative">
            <div v-if="false" class="w-full">
               <span class="text-grap-700 align-middle">{{lang['components']['Event']['AdvertisingMaterial']['material_block_image']}}</span>
            </div>
            <div
              v-if="false"
              v-for="(item, i) in image.imageList"
              :key="i"
            >
              <img
                @click="changeSelectedForm(i, 'image')"
                :class="{ 'border-blue-light': image.active == i }"
                :src="image.imageList[i]"
                class="
                  flex-none
                  m-2
                  mb-4
                  w-24
                  h-24
                  border-4 border-transparent
                  object-cover
                  rounded-xl
                  cursor-pointer
                "
                :title="image.imageListTitle[i]"
              />
              <div
                class="text-center -mt-2 w-28"
              >
                {{image.imageListName[i]}}
              </div>
            </div>
            <div v-if="false" class="w-full mt-4 text-center">
              <button
                class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
                @click="moreImage()"
              >{{lang['components']['Event']['AdvertisingMaterial']['more_image']}}</button>
            </div>
            <div class="w-full h-8">
               <span class="text-grap-700 align-middle">{{lang['components']['Event']['AdvertisingMaterial']['material_block_video']}}</span>
            </div>
            <div
              v-for="(item, i) in video.videoList"
              :key="i"
            >
              <img
                @click="changeSelectedForm(i, 'video')"
                :class="{ 'border-blue-light': video.active == i }"
                :src="video.videoList[i]"
                class="
                  flex-none
                  m-2
                  mb-4
                  w-24
                  h-24
                  border-4 border-transparent
                  object-cover
                  rounded-xl
                  cursor-pointer
                "
                :title="video.videoListTitle[i]"
              />
              <div
                class="text-center -mt-2 w-28"
              >
                {{video.videoListName[i]}}
              </div>
            </div>
            <div v-if="videoAfter != ''" class="w-full mt-4 text-center">
              <button
                class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
                @click="moreVideo()"
              >{{lang['components']['Event']['AdvertisingMaterial']['more_video']}}</button>
            </div>
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <div class="text-right">
          <button @click="setMaterial(currentTab)" class="button bg-yellow" style="margin-right:48px;">{{lang['components']['Event']['AdvertisingMaterial']['set_material']}}</button>
        </div>
      </template>
    </ModifyWindows>
  </div>
</template>
<script>
import InputSwitch from 'primevue/inputswitch';
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Dropdown from "primevue/dropdown";
import fb1Image from "@/assets/fb_1.png";
import fb2Image from "@/assets/fb_2.png";
import ModifyWindows from "@/components/ModifyWindows.vue";
import draggable from "vuedraggable";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import axios from 'axios'
import Qs from 'qs'

export default {
  name: "AdvertisingMaterial",
  components: {
    InputSwitch,
    TabView,
    TabPanel,
    Dropdown,
    ModifyWindows,
    draggable,
    Loading
  },
  props: {
    // <!-- 新手教學 -->
    guideStep: {
      type: Number,
      default: 1
    },
    // <!-- 新手教學 -->
    editPage: {
      type: Boolean
    },
    viewDatalist: {
      type: Object
    },
    stageContent:{
      type: Object
    },
    stageContentAll:{
      type: Object
    },
    stageIndex: {
      type: Number
    },
    returnCampaignObjective: {
      type: String
    },
    pageId: {
      type: String
    },
    goalsObjective:{
      type:String
    },
    changeFormId: {
      type: Number
    },
    changeMessageId: {
      type: Number
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      isEdit: false,
      useStatus: false,
      showMaterialSingle: true,
      showMaterial: true,
      showVideoLoading: true,
      currentTab: 0,
      fb1Image: fb1Image,
      fb2Image: fb2Image,
      auto: true,
      type: 1,
      activeType: 1,
      activeItem: 0,
      focusType: 0,
      selectedForm: 'image',
      prview_now: null,
      prview_single: null,
      nowItemIndex: 0,
      materials: [],
      showModal: false,
      call: null,
      moreInput: true,
      items: [],
      showVideoWindows: false,
      image: {
        active: null,
        imageList: [
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg"
        ],
        imageListSpec: [],
        imageListName: [],
        imageListTitle: []
      },
      video: {
        active: null,
        videoList: [
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg"
        ],
        videoListSpec: [],
        videoListName: [],
        videoListTitle: []
      },
      imageAfter: '',
      videoAfter: '',
      materialSingle: [],
      callActiveList: [],
      jsonContent: [],
      _useStatus: false,
    };
  },
  watch: {
    lang(value){
    //  console.log('AdvertisingMaterial value');
    //  console.log(value);

      this.viewDatalistData.creative_array = [
        {
          title: this.lang['components']['Event']['AdvertisingMaterial']['item_title'],
          isEdit: false,
          type: 1,
          tagType: 0,
          materials: [
            {
              id: null,
              imgSrc: null,
              object_spec: {
                name: null,
                width: null,
                height: null
              },
              title: null,
              description: null,
              website: null,
              isEdit: false,
              index: 0
            },
            {
              id: null,
              imgSrc: null,
              object_spec: {
                name: null,
                width: null,
                height: null
              },
              title: null,
              description: null,
              website: null,
              isEdit: false,
              index: 1
            }
          ],
          materialSingle: [
            {
              id: null,
              imgSrc: null,
              object_spec: {
                name: null,
                width: null,
                height: null
              },
              fileName: null,
              title: null,
              description: null,
              website: null,
              size: null,
              index: 0
            }
          ],
          callActive: 'SIGN_UP',
          form_sr_i: null,
          message_sr_i: null
        },
      ];

      this.callActiveList = [
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['apply_now'],
          code: 'APPLY_NOW'
        },
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['book_travel'],
          code: 'BOOK_TRAVEL'
        },
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['download'],
          code: 'DOWNLOAD'
        },
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['get_offer'],
          code: 'GET_OFFER'
        },
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['get_quote'],
          code: 'GET_QUOTE'
        },
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['learn_more'],
          code: 'LEARN_MORE'
        },
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['sign_up'],
          code: 'SIGN_UP'
        },
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['subscribe'],
          code: 'SUBSCRIBE'
        }
      ];
    },
    'stageContenttData': function(v){
    //  console.log('CustomizeTiktokEvent AdvertisingMaterial stageContenttData');
    //  console.log(v);
    //  console.log(this.stageIndex);
    //  console.log(this.stageContentAllData);

      let _beforeIndex = this.stageIndex - 1;
      let _tmpThisMethod = this.stageContentAllData.subCampaignsContent[this.stageIndex].method;
      let _tmpBeforeMethod = '';
      let metaList = ['META_TEST','META_KW','META_LA','META_RT','META_ASC'];
      let tiktokList = ['TIKTOK_KW','TIKTOK_RT'];

    //  console.log('_beforeIndex');
    //  console.log(_beforeIndex);
      if(_beforeIndex >= 0){
        _tmpBeforeMethod = this.stageContentAllData.subCampaignsContent[_beforeIndex].method;
      }

    //  console.log(_tmpThisMethod+' vs '+_tmpBeforeMethod);

      let _thisIsMeta = false;
      let _beforeIsMeta = false;
      let _thisIsTiktok = false;
      let _beforeIsTiktok = false;
      let _allIsMeta = false;
      let _allIsTiktok = false;

      if (metaList.includes(_tmpThisMethod)) {
        _thisIsMeta = true
      }

      if (metaList.includes(_tmpBeforeMethod)) {
        _beforeIsMeta = true
      }

      if (tiktokList.includes(_tmpThisMethod)) {
        _thisIsTiktok = true
      }

      if (tiktokList.includes(_tmpBeforeMethod)) {
        _beforeIsTiktok = true
      }

      if(_thisIsMeta == true && _beforeIsMeta == true){
        _allIsMeta = true;
      }

      if(_thisIsTiktok == true && _beforeIsTiktok == true){
        _allIsTiktok = true;
      }

      if(_allIsMeta == true || _allIsTiktok == true){
        this._useStatus = true;
      } else {
        this._useStatus = false;
      }

    //  console.log('_thisIsMeta');
    //  console.log(_thisIsMeta);
    //  console.log('_beforeIsMeta');
    //  console.log(_beforeIsMeta);
    //  console.log('_thisIsTiktok');
    //  console.log(_thisIsTiktok);
    //  console.log('_beforeIsTiktok');
    //  console.log(_beforeIsTiktok);
    //  console.log('_allIsMeta');
    //  console.log(_allIsMeta);
    //  console.log('_allIsTiktok');
    //  console.log(_allIsTiktok);
    //  console.log('this._useStatus');
    //  console.log(this._useStatus);
    },
    'viewDatalist': function(value){
    //  console.log('advertising viewDatalistData');
      // console.log(this.viewDatalistData);
    //  console.log(value);

      // console.log(this.viewDatalistData.creative_array);
      if(value.creative_array != "" && value.creative_array != null && typeof value.creative_array != 'undefined'){
      //  console.log('is creative_array');
        for(let i = 0; i < value.creative_array.length; i++){
          this.jsonContent[i] = JSON.stringify(value.creative_array[i]);
        }

        this.viewDatalistData.creative_array = value.creative_array;

      //  console.log('this.jsonContent');
      //  console.log(this.jsonContent);
      } else {
      //  console.log('not creative_array');
        if(value.creative_array == "" || value.creative_array == null || typeof value.creative_array == 'undefined'){
          this.viewDatalistData.creative_array = [
            {
              title: this.lang['components']['Event']['AdvertisingMaterial']['item_title'],
              isEdit: false,
              type: 1,
              tagType: 0,
              materials: [
                {
                  id: null,
                  imgSrc: null,
                  object_spec: {
                    name: null,
                    width: null,
                    height: null
                  },
                  title: null,
                  description: null,
                  website: null,
                  isEdit: false,
                  index: 0
                },
                {
                  id: null,
                  imgSrc: null,
                  object_spec: {
                    name: null,
                    width: null,
                    height: null
                  },
                  title: null,
                  description: null,
                  website: null,
                  isEdit: false,
                  index: 1
                }
              ],
              materialSingle: [
                {
                  id: null,
                  imgSrc: null,
                  object_spec: {
                    name: null,
                    width: null,
                    height: null
                  },
                  fileName: null,
                  title: null,
                  description: null,
                  website: null,
                  size: null,
                  index: 0
                }
              ],
              callActive: 'SIGN_UP',
              form_sr_i: null,
              message_sr_i: null
            }
          ];
        } else {
          this.viewDatalistData.creative_array = value;
        }
      }

    //  console.log('viewDatalist this.viewDatalistData.creative_array');
    //  console.log(this.viewDatalistData.creative_array);
    },
    'goalsObjectiveData': function(v){
      // console.log('ad goalsObjectiveData');
      // console.log(v);

      if(v == 'LEAD_GENERATION'){
        this.callActiveList = [
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['apply_now'],
            code: 'APPLY_NOW'
          },
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['book_travel'],
            code: 'BOOK_TRAVEL'
          },
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['download'],
            code: 'DOWNLOAD'
          },
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['get_offer'],
            code: 'GET_OFFER'
          },
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['get_quote'],
            code: 'GET_QUOTE'
          },
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['learn_more'],
            code: 'LEARN_MORE'
          },
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['sign_up'],
            code: 'SIGN_UP'
          },
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['subscribe'],
            code: 'SUBSCRIBE'
          }
        ]
      }

      if(v == 'MESSAGES'){
        this.callActiveList = [
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['messages']['message_page'],
            code: 'MESSAGE_PAGE'
          }
        ]
      }
    },
    changeFormId (value){
    //  console.log('已改變changeFormId');
    //  console.log(value);

      let get_value = value.split('_');
      // console.log('item index:');
      // console.log(this.nowItemIndex);
      // console.log('b item:');
      // console.log(this.viewDatalistData.creative_array);
      this.viewDatalistData.creative_array[this.nowItemIndex].form_sr_i = parseInt(get_value[0])
    //  console.log('a item:');
    //  console.log(this.viewDatalistData.creative_array);

      // this.$emit('baseChangeFormId');
      // console.log('baseChangeFormId');
    },
    changeMessageId (value){
    //  console.log('已改變changeMessageId');
    //  console.log(value);

      let get_value = value.split('_');
      // console.log('item index:');
      // console.log(this.nowItemIndex);
      // console.log('b item:');
      // console.log(this.viewDatalistData.creative_array);
      this.viewDatalistData.creative_array[this.nowItemIndex].message_sr_i = parseInt(get_value[0])
    //  console.log('a item:');
    //  console.log(this.viewDatalistData.creative_array);
    },
    // <!-- 新手教學 -->
    guideStep(val) {
    //  console.log('advertisingmaterial guideStep')
    //  console.log(val)
      if (val === 67) {
        this.changeType(0, 2);
      }

      if (val === 71) {
        this.viewDatalistData.creative_array[0].materials[0].isEdit = !this.viewDatalistData.creative_array[0].materials[0].isEdit;
      }
    }
    // <!-- 新手教學 -->
  },
  methods: {
    unlock(){
      this.isEdit = false
    },
    lock(){
      this.isEdit = true
    },
    changeType(index, value){
      // if(this.editPageType == false){
        this.viewDatalistData.creative_array[index].type = value
        this.focusType = index

        this.$emit('childContent', this.viewDatalistData.creative_array);

        // console.log('changeType');
        // console.log('viewDatalistData.creative_array['+index+'].type');
        // console.log(this.viewDatalistData.creative_array[index].type);
        // console.log('focusType');
        // console.log(this.focusType);
      // }
    },
    changeSelectedForm(index, value){
      // if(this.editPageType == false){
        if(value == 'image'){
          this.image.active = index
          this.selectedForm = 'image'
        } else {
          this.video.active = index
          this.selectedForm = 'video'
        }

        this.$emit('childContent', this.viewDatalistData.creative_array);
      // }
    },
    addItem() {
      // this.viewDatalistData.creative_array.push({ title: "xxxxxx" });
      // if(this.editPageType == false){
        this.viewDatalistData.creative_array.push(
          {
            title: this.lang['components']['Event']['AdvertisingMaterial']['item_title'],
            isEdit: false,
            type: 1,
            tagType: 0,
            materials: [
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                title: null,
                description: null,
                website: null,
                isEdit: false,
                index: 0
              },
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                title: null,
                description: null,
                website: null,
                isEdit: false,
                index: 1
              }
            ],
            materialSingle: [
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                fileName: null,
                title: null,
                description: null,
                website: null,
                size: null,
                index: 0
              }
            ],
            callActive: 'SIGN_UP',
            form_sr_i: null,
            message_sr_i: null
          }
        );

      //  console.log('addItem this.viewDatalistData.creative_array');
      //  console.log(this.viewDatalistData.creative_array);

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.viewDatalistData.creative_array);
      // }
    },
    setMaterial(type) {
      let activeType = this.activeType
      let activeItem = this.activeItem

      // console.log('setMaterial type:'+type);
      // console.log('setMaterial activeType:'+activeType);
      // console.log('setMaterial activeItem:'+activeItem);

      // if(this.editPageType == false){
        if(activeType == 1){
          // if(this.selectedForm == 'image'){
          //   if (
          //     this.image.active != null &&
          //     this.image.imageList.length > this.image.active
          //   ) {
          //     // this.viewDatalistData.creative_array.materialSingle == []

          //     // console.log('1 image this.image.active');
          //     // console.log(this.image.active);
          //     // console.log('this.image');
          //     // console.log(this.image);

          //     this.viewDatalistData.creative_array[type].materialSingle = [{
          //       id: this.image.imageListSpec[this.image.active].id,
          //       imgSrc: this.image.imageList[this.image.active],
          //       object_spec: this.image.imageListSpec[this.image.active],
          //       fileName: this.image.imageListSpec[this.image.active].name,
          //       title: this.viewDatalistData.creative_array[type].materialSingle[0].title,
          //       description: this.viewDatalistData.creative_array[type].materialSingle[0].description,
          //       website: this.viewDatalistData.creative_array[type].materialSingle[0].website,
          //       size: this.image.imageListSpec[this.image.active].width+' * '+this.image.imageListSpec[this.image.active].height,
          //       index: 0
          //     }];

          //     this.image.active = null;
          //     this.showVideoWindows = false;
          //   }
          // } else {
            if (
              this.video.active != null &&
              this.video.videoList.length > this.video.active
            ) {
              // this.viewDatalistData.creative_array.materialSingle == []

            //  console.log('1 video this.video.active');
            //  console.log(this.video.active);
            //  console.log('this.video');
            //  console.log(this.video);
            //  console.log('b this.viewDatalistData.creative_array');
            //  console.log(this.viewDatalistData.creative_array);

              this.viewDatalistData.creative_array[type].materialSingle = [{
                id: this.video.videoListSpec[this.video.active].video_id,
                imgSrc: this.video.videoList[this.video.active],
                object_spec: this.video.videoListSpec[this.video.active],
                fileName: this.video.videoListSpec[this.video.active].file_name,
                title: this.viewDatalistData.creative_array[type].materialSingle[0].title,
                description: this.viewDatalistData.creative_array[type].materialSingle[0].description,
                website: this.viewDatalistData.creative_array[type].materialSingle[0].website,
                size: this.video.videoListSpec[this.video.active].width+' * '+this.video.videoListSpec[this.video.active].height,
                index: 0
              }];

              this.video.active = null;
              this.showVideoWindows = false;
            }
          // }
        }

        // if(activeType == 2){
        //   let this_length = this.viewDatalistData.creative_array[type].materials.length;
        //   if(this.selectedForm == 'image'){
        //     if (
        //       this.image.active != null &&
        //       this.image.imageList.length > this.image.active
        //     ) {
        //       // this.viewDatalistData.creative_array.materials == []

        //       // console.log('2 image this.image.active');
        //       // console.log(this.image.active);
        //       // console.log(this.image.imageList[this.image.active]);
        //       // console.log(this.viewDatalistData.creative_array);
        //       // console.log(this.viewDatalistData.creative_array[activeType]);
        //       // console.log('this.image');
        //       // console.log(this.image);

        //       // this.viewDatalistData.creative_array[activeType].materials.push({
        //       //   imgSrc: this.image.imageList[this.image.active],
        //       //   title: "",
        //       //   size: "800*800"
        //       // });

        //       if(typeof this.viewDatalistData.creative_array[type].materials[activeItem].index != 'undefined'){
        //         this_length = this.viewDatalistData.creative_array[type].materials[activeItem].index;
        //       }

        //       this.viewDatalistData.creative_array[type].materials[activeItem] = {
        //         id: this.image.imageListSpec[this.image.active].id,
        //         imgSrc: this.image.imageList[this.image.active],
        //         object_spec: this.image.imageListSpec[this.image.active],
        //         title: this.viewDatalistData.creative_array[type].materials[activeItem].title,
        //         description: this.viewDatalistData.creative_array[type].materials[activeItem].description,
        //         website: this.viewDatalistData.creative_array[type].materials[activeItem].website,
        //         size: "",
        //         isEdit: true,
        //         index: this_length
        //       };

        //       // console.log(this.viewDatalistData.creative_array[type]);

        //       this.image.active = null;
        //       this.showVideoWindows = false;
        //     }
        //   } else {
        //     if (
        //       this.video.active != null &&
        //       this.video.videoList.length > this.video.active
        //     ) {
        //       // this.viewDatalistData.creative_array.materials == []

        //       // console.log('2 video this.video.active');
        //       // console.log(this.video.active);
        //       // console.log('this.video');
        //       // console.log(this.video);

        //       // this.viewDatalistData.creative_array[activeType].materials.push({
        //       //   imgSrc: this.video.videoList[this.video.active],
        //       //   title: "",
        //       //   size: "800*800"
        //       // });

        //       if(typeof this.viewDatalistData.creative_array[type].materials[activeItem].index != 'undefined'){
        //         this_length = this.viewDatalistData.creative_array[type].materials[activeItem].index;
        //       }

        //       this.viewDatalistData.creative_array[type].materials[activeItem] = {
        //         id: this.video.videoListSpec[this.video.active].id,
        //         imgSrc: this.video.videoList[this.video.active],
        //         object_spec: this.video.videoListSpec[this.video.active],
        //         title: this.viewDatalistData.creative_array[type].materials[activeItem].title,
        //         description: this.viewDatalistData.creative_array[type].materials[activeItem].description,
        //         website: this.viewDatalistData.creative_array[type].materials[activeItem].website,
        //         size: "",
        //         isEdit: true,
        //         index: this_length
        //       };

        //       this.video.active = null;
        //       this.showVideoWindows = false;
        //     }
        //   }
        // }

      //  console.log('a this.viewDatalistData.creative_array');
      //  console.log(this.viewDatalistData.creative_array);

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.viewDatalistData.creative_array);

        this.adPreview(this.currentTab);
      // }

      // console.log('this.viewDatalistData.creative_array');
      // console.log(this.viewDatalistData.creative_array);
    },
    getImageVideoList(type, index){
      // console.log('getImageVideoList type:'+type);
      // console.log('getImageVideoList index:');
      // console.log(index);

      // if(this.editPageType == false){

        // if(type == 1){
        //   this.showMaterialSingle = false;
        // } else {
        //   this.showMaterial = false;
        // }

        this.showVideoWindows = true;
        this.showVideoLoading = false;

        this.image.imageList = null;
        this.image.imageListSpec = null;
        this.image.imageListName = null;
        this.image.imageListTitle = null;
        this.video.videoList = null;
        this.video.videoListSpec = null;
        this.video.videoListName = null;
        this.video.videoListTitle = null;

        this.activeType = null;
        this.activeItem = null;

        let _tmpAdaccountId = this.$route.params.adaccount_id.split('___');

        axios
          .post('https://www.autoturn.net/api/customize/campaign/tiktok_campaign_advideos.php', Qs.stringify({
            s_code: this.$route.params.id,
            advertiser_id: _tmpAdaccountId[1],
          }))
          .then((response) => {
            // if(response.data.status == 'success'){
              this.videoAfter = response.data.after_video

              this.video.videoList = response.data.return_video
              this.video.videoListSpec = response.data.return_video_spec
              this.video.videoListName = response.data.return_video_name
              this.video.videoListTitle = response.data.return_video_title

              this.activeType = type
              this.activeItem = index

              // if(type == 1){
              //   this.showMaterialSingle = true;
              // } else {
              //   this.showMaterial = true;
              // }

              // this.showVideoWindows = true

              this.showVideoLoading = true;
            // }
          });
      // }
    },
    moreVideo(){
    //  console.log('moreVideo');

      // let thisVideoList = ['video111.jpg','video222.jpg'];
      // let thisVideoListSpec = ['111','222'];
      // let thisVideoListName = ['video111','video222'];
      // let thisVideoListTitle = ['video111','video222'];

      this.showVideoLoading = false;

      let _tmpAdaccountId = this.$route.params.adaccount_id.split('___');

      axios
        .post('https://www.autoturn.net/api/customize/campaign/tiktok_campaign_advideos.php', Qs.stringify({
          s_code: this.$route.params.id,
          advertiser_id: _tmpAdaccountId[1],
          video_material_code: this.videoAfter,
        }))
        .then((response) => {
          // if(response.data.status == 'success'){
            // this.video.videoList = response.data.return_video
            // this.video.videoListSpec = response.data.return_video_spec
            // this.video.videoListName = response.data.return_video_name
            // this.video.videoListTitle = response.data.return_video_title

            // if(type == 1){
            //   this.showMaterialSingle = true;
            // } else {
            //   this.showMaterial = true;
            // }

            // this.showVideoWindows = true

            // this.showVideoLoading = true;
            this.videoAfter = response.data.after_video;

            this.video.videoList = response.data.return_video;
            this.video.videoListSpec = response.data.return_video_spec;
            this.video.videoListName = response.data.return_video_name;
            this.video.videoListTitle = response.data.return_video_title;

            this.showVideoLoading = true;
          // }
        });
    },
    moreImage(){
    //  console.log('moreImage');

      // let thisImageList = ['image111.jpg','image222.jpg'];
      // let thisImageListSpec = ['111','222'];
      // let thisImageListName = ['image111','image222'];
      // let thisImageListTitle = ['image111','image222'];

      this.showVideoLoading = false;

      axios
        .post('https://www.autoturn.net/api/campaign_form_adimages.php', Qs.stringify({
          s_code: this.$route.params.id,
          advertiser_id: this.$route.params.adaccount_id,
          image_material_code: this.imageAfter,
        }))
        .then((response) => {
          // if(response.data.status == 'success'){
            // this.image.imageList = response.data.return_image
            // this.image.imageListSpec = response.data.return_image_spec
            // this.image.imageListName = response.data.return_image_name
            // this.image.imageListTitle = response.data.return_image_title

            // if(type == 1){
            //   this.showMaterialSingle = true;
            // } else {
            //   this.showMaterial = true;
            // }

            // this.showVideoWindows = true

            // this.showVideoLoading = true;
            this.imageAfter = response.data.after_image;

            this.image.imageList = response.data.return_image;
            this.image.imageListSpec = response.data.return_image_spec;
            this.image.imageListName = response.data.return_image_name;
            this.image.imageListTitle = response.data.return_image_title;

            this.showVideoLoading = true;
          // }
        });
    },
    adContent(index){
    //  console.log('adContent');
    //  console.log(index);
    //  console.log('this.viewDatalistData.creative_array['+index+'].form_sr_i');
    //  console.log(this.viewDatalistData.creative_array[index].form_sr_i);
    //  console.log('this.viewDatalistData.creative_array['+index+'].message_sr_i');
    //  console.log(this.viewDatalistData.creative_array[index].message_sr_i);

      this.prview_single = null;

      // if(this.editPageType == false){
        this.currentTab = index
        this.prview_now = this.viewDatalistData.creative_array[index].preview

        this.adPreview(index);

        this.nowItemIndex = index;
        this.$emit('childFormId', this.viewDatalistData.creative_array[index].form_sr_i);
        this.$emit('childMessageId', this.viewDatalistData.creative_array[index].message_sr_i);
      // }
    },
    addMaterials(index){
      // console.log('addMaterials:'+index);
      let this_length = this.viewDatalistData.creative_array[index].materials.length;

      // if(this.editPageType == false){
        if(this_length < 10){
          this.viewDatalistData.creative_array[index].materials.push({
            id: null,
            imgSrc: null,
            object_spec: {
              name: null,
              width: null,
              height: null
            },
            title: null,
            description: null,
            website: null,
            isEdit: false,
            index: this_length
          });

          this.$emit('childAdIsChangeData', true);
          this.$emit('childContent', this.viewDatalistData.creative_array);

          this.adPreview(this.currentTab);
        } else {
          Swal.fire(
                    this.lang['components']['Event']['AdvertisingMaterial']['methods']['addMaterials']['not_length_swal_title'],
                    this.lang['components']['Event']['AdvertisingMaterial']['methods']['addMaterials']['not_length_swal_text'],
                    'warning'
                  );
        }
      // }

      // console.log(this.viewDatalistData.creative_array[index].materials);
    },
    removeAd(index){
      // console.log('removeAd index:'+index);

      // if(this.editPageType == false){
        this.viewDatalistData.creative_array.splice(index, 1);

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.viewDatalistData.creative_array);
      // }
    },

    backAd(index){
    //  console.log('backAd index:'+index);
    //  console.log(this.viewDatalistData.creative_array);

      // if(this.editPageType == false){
        this.viewDatalistData.creative_array[index].tagType = 1;

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.viewDatalistData.creative_array);
      // }
    },
    isChangeData(){
      // console.log('isChangeData');

      this.$emit('childAdIsChangeData', true);
      this.$emit('childContent', this.viewDatalistData.creative_array);

      this.adPreview(this.currentTab);
    },
    removeItem(type, index){
      // console.log('removeItem type:'+type);
      // console.log('removeItem index:'+index);

      // if(this.editPageType == false){
        // console.log('b this.viewDatalistData.creative_array:');
        // console.log(this.viewDatalistData.creative_array);
        // console.log('this.viewDatalistData.creative_array['+type+'].materials:');
        // console.log(this.viewDatalistData.creative_array[type].materials);
        this.viewDatalistData.creative_array[type].materials.splice(index, 1);

        for(var i = 0; i < this.viewDatalistData.creative_array[type].materials.length; i++){
          this.viewDatalistData.creative_array[type].materials[i].index = i;
        }

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.viewDatalistData.creative_array);

        // console.log('a this.viewDatalistData.creative_array:');
        // console.log(this.viewDatalistData.creative_array);
      // }
    },
    adPreview(index){
    //  console.log('adPreview');
    //  console.log(index);
    //  console.log(this.viewDatalistData.creative_array[index]);

      axios
          .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_ads_preview.php', Qs.stringify({
            s_code: this.$route.params.id,
            advertiser_id: this.$route.params.adaccount_id,
            identity_id: this.pageId,
            items: this.viewDatalistData.creative_array[index]
          }))
          .then((response) => {
            // console.log(response.data);
            if(response.data.status == 'success'){

              this.prview_now = null;

              this.prview_single = response.data.return_data
              // this.image.imageList = response.data.return_image
              // this.image.imageListSpec = response.data.return_image_spec
              // this.video.videoList = response.data.return_video
              // this.video.videoListSpec = response.data.return_video_spec

              // this.activeType = type
              // this.activeItem = index

              // if(type == 1){
              //   this.showMaterialSingle = true;
              // } else {
              //   this.showMaterial = true;
              // }

              // this.showVideoWindows = true
            }
          });
    },
    materialUpdate(){
    //  console.log('materialUpdate');
      this.showVideoLoading = false;

      this.image.imageList = null;
      this.image.imageListSpec = null;
      this.image.imageListName = null;
      this.image.imageListTitle = null;
      this.video.videoList = null;
      this.video.videoListSpec = null;
      this.video.videoListName = null;
      this.video.videoListTitle = null;

      // axios
      //   .post('https://www.autoturn.net/api/campaign_form_adimages.php', Qs.stringify({
      //     s_code: this.$route.params.id,
      //     advertiser_id: this.$route.params.adaccount_id,
      //     type: 'update'
      //   }))
      //   .then((response) => {
      //     if(response.data.status == 'success'){
      //       this.imageAfter = response.data.after_image

      //       this.image.imageList = response.data.return_image
      //       this.image.imageListSpec = response.data.return_image_spec
      //       this.image.imageListName = response.data.return_image_name
      //       this.image.imageListTitle = response.data.return_image_title

      //       // if(type == 1){
      //       //   this.showMaterialSingle = true;
      //       // } else {
      //       //   this.showMaterial = true;
      //       // }

      //       // this.showVideoWindows = true

      //       // this.showVideoLoading = true;

            let _tmpAdaccountId = this.$route.params.adaccount_id.split('___');

            axios
              .post('https://www.autoturn.net/api/customize/campaign/tiktok_campaign_advideos.php', Qs.stringify({
                s_code: this.$route.params.id,
                advertiser_id: _tmpAdaccountId[1],
                type: 'update'
              }))
              .then((response) => {
                // if(response.data.status == 'success'){
                  this.videoAfter = response.data.after_video

                  this.video.videoList = response.data.return_video
                  this.video.videoListSpec = response.data.return_video_spec
                  this.video.videoListName = response.data.return_video_name
                  this.video.videoListTitle = response.data.return_video_title

                  // if(type == 1){
                  //   this.showMaterialSingle = true;
                  // } else {
                  //   this.showMaterial = true;
                  // }

                  // this.showVideoWindows = true

                  this.showVideoLoading = true;
                // }
              });
        //   } else {
        //     axios
        //       .post('https://www.autoturn.net/api/campaign_form_advideos.php', Qs.stringify({
        //         s_code: this.$route.params.id,
        //         advertiser_id: this.$route.params.adaccount_id,
        //         type: 'update'
        //       }))
        //       .then((response) => {
        //         // if(response.data.status == 'success'){
        //           this.videoAfter = response.data.after_video

        //           this.video.videoList = response.data.return_video
        //           this.video.videoListSpec = response.data.return_video_spec
        //           this.video.videoListName = response.data.return_video_name
        //           this.video.videoListTitle = response.data.return_video_title

        //           // if(type == 1){
        //           //   this.showMaterialSingle = true;
        //           // } else {
        //           //   this.showMaterial = true;
        //           // }

        //           // this.showVideoWindows = true

        //           this.showVideoLoading = true;
        //         // }
        //       });
        //   }
        // });
    }
  },
  computed: {
    moreWording() {
      return this.moreInput ? "隱藏" : "顯示";
    },
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
    viewDatalistData: {
      get: function () {
        return this.viewDatalist
      },
      set: function (value) {
        this.$emit('update:viewDatalistData', value)
      },
    },
    stageContenttData:{
      get: function () {
        return this.stageContent
      },
      set: function (value) {
        this.$emit('update:stageContenttData', value)
      },
    },
    stageContentAllData:{
      get: function () {
        return this.stageContentAll
      },
      set: function (value) {
        this.$emit('update:stageContentAllData', value)
      },
    },
    returnCampaignObjectiveData: {
      get: function () {
        return this.returnCampaignObjective
      },
      set: function (value) {
        this.$emit('update:returnCampaignObjectiveData', value)
      },
    },
    goalsObjectiveData: {
      get: function () {
        return this.goalsObjective
      },
      set: function (value) {
        this.$emit('update:goalsObjectiveData', value)
      },
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep(.tab) {
  .p-tabview .p-tabview-nav {
    display: none;
  }

  .p-tabview .p-tabview-panels {
    padding: 0px;
  }
}
</style>
